// Traduções da gestão desconsiderada e da gestão sem ocorrência no Hub (29/10/2026). Coletadas por glob em
// core/i18n/messages.ts.
export default {
  pt: {
    'gestoes.manual.botao': 'Gerar gestão sem ocorrência no Hub',
    'gestoes.manual.titulo': 'Gerar gestão sem ocorrência no Hub',
    'gestoes.manual.colaborador': 'Colaborador',
    'gestoes.manual.data': 'Data da ocorrência',
    'gestoes.manual.texto': 'Texto da gestão',
    'gestoes.manual.hint': 'Para a ocorrência que o Hub não registra, como o caminhão que saiu da rota programada. A gestão nasce em Gestões Pendentes, e o Gerar Texto devolve este texto.',
    'gestoes.manual.erro': 'Informe o colaborador, o tipo, a data da ocorrência e o texto da gestão.',
    'gestoes.manual.ok': 'Gestão gerada. Ela está em Gestões Pendentes.',
    'advertencias.origem.manual': 'Fora do Hub',
    'jornada.infracao.tipo.fora_do_hub': 'Ocorrência fora do Hub',
    'gestoes.aba.desconsiderada': 'Gestões Desconsideradas',
    'gestoes.status.desconsiderada': 'Desconsiderada',
    'gestoes.desconsiderar': 'Desconsiderar gestão',
    'gestoes.desconsiderarCurto': 'Desconsiderar',
    'gestoes.desconsideradaOk': 'Gestão desconsiderada. Ela está agora em Gestões Desconsideradas.',
    'gestoes.desconsideracao': 'Desconsideração',
    'gestoes.desconsideracao.solicitante': 'Quem pediu para desconsiderar',
    'gestoes.desconsideracao.justificativa': 'Justificativa',
    'gestoes.desconsideracao.data': 'Desconsiderada em',
    'gestoes.desconsideracao.por': 'Desconsiderada por',
    'gestoes.desconsideracao.hint': 'Use quando o colaborador justificou a ocorrência. A gestão sai das abas Pendentes e Aplicadas e vai para Gestões Desconsideradas, e as ocorrências continuam tratadas no Relatório de Ocorrências.',
    'gestoes.desconsideracao.erro': 'Informe a justificativa e quem pediu para desconsiderar.',
    'gestoes.acao.desconsiderar': 'Gestão desconsiderada',
    'gestoes.vazio.desconsiderada': 'Nenhuma gestão desconsiderada com os filtros atuais.',
    'gestoes.hint.desconsiderada': 'Gestões desconsideradas porque o colaborador justificou. O período e as datas filtram pela data da ocorrência, na folha do dia 16 ao dia 15; sem data, aparecem todas.',
  },
  en: {
    'gestoes.manual.botao': 'Create measure without a Hub occurrence',
    'gestoes.manual.titulo': 'Create measure without a Hub occurrence',
    'gestoes.manual.colaborador': 'Employee',
    'gestoes.manual.data': 'Occurrence date',
    'gestoes.manual.texto': 'Measure text',
    'gestoes.manual.hint': 'For an occurrence the Hub does not record, like a truck that left the planned route. The measure starts in Pending measures, and Generate text returns this text.',
    'gestoes.manual.erro': 'Enter the employee, the type, the occurrence date and the measure text.',
    'gestoes.manual.ok': 'Measure created. It is in Pending measures.',
    'advertencias.origem.manual': 'Outside the Hub',
    'jornada.infracao.tipo.fora_do_hub': 'Occurrence outside the Hub',
    'gestoes.aba.desconsiderada': 'Disregarded measures',
    'gestoes.status.desconsiderada': 'Disregarded',
    'gestoes.desconsiderar': 'Disregard measure',
    'gestoes.desconsiderarCurto': 'Disregard',
    'gestoes.desconsideradaOk': 'Measure disregarded. It is now in Disregarded measures.',
    'gestoes.desconsideracao': 'Disregard',
    'gestoes.desconsideracao.solicitante': 'Who asked to disregard',
    'gestoes.desconsideracao.justificativa': 'Reason',
    'gestoes.desconsideracao.data': 'Disregarded on',
    'gestoes.desconsideracao.por': 'Disregarded by',
    'gestoes.desconsideracao.hint': 'Use it when the employee justified the occurrence. The measure leaves the Pending and Applied tabs and goes to Disregarded measures, and the occurrences stay handled in the Occurrence report.',
    'gestoes.desconsideracao.erro': 'Enter the reason and who asked to disregard.',
    'gestoes.acao.desconsiderar': 'Measure disregarded',
    'gestoes.vazio.desconsiderada': 'No disregarded measures for the current filters.',
    'gestoes.hint.desconsiderada': 'Measures disregarded because the employee justified them. The period and dates filter by occurrence date, in the payroll from the 16th to the 15th; without a date, all are shown.',
  },
  es: {
    'gestoes.manual.botao': 'Generar gestión sin ocurrencia en el Hub',
    'gestoes.manual.titulo': 'Generar gestión sin ocurrencia en el Hub',
    'gestoes.manual.colaborador': 'Colaborador',
    'gestoes.manual.data': 'Fecha de la ocurrencia',
    'gestoes.manual.texto': 'Texto de la gestión',
    'gestoes.manual.hint': 'Para la ocurrencia que el Hub no registra, como el camión que salió de la ruta programada. La gestión nace en Gestiones pendientes, y Generar texto devuelve este texto.',
    'gestoes.manual.erro': 'Informe el colaborador, el tipo, la fecha de la ocurrencia y el texto de la gestión.',
    'gestoes.manual.ok': 'Gestión generada. Está en Gestiones pendientes.',
    'advertencias.origem.manual': 'Fuera del Hub',
    'jornada.infracao.tipo.fora_do_hub': 'Ocurrencia fuera del Hub',
    'gestoes.aba.desconsiderada': 'Gestiones desconsideradas',
    'gestoes.status.desconsiderada': 'Desconsiderada',
    'gestoes.desconsiderar': 'Desconsiderar gestión',
    'gestoes.desconsiderarCurto': 'Desconsiderar',
    'gestoes.desconsideradaOk': 'Gestión desconsiderada. Ahora está en Gestiones desconsideradas.',
    'gestoes.desconsideracao': 'Desconsideración',
    'gestoes.desconsideracao.solicitante': 'Quién pidió desconsiderar',
    'gestoes.desconsideracao.justificativa': 'Justificación',
    'gestoes.desconsideracao.data': 'Desconsiderada el',
    'gestoes.desconsideracao.por': 'Desconsiderada por',
    'gestoes.desconsideracao.hint': 'Úselo cuando el colaborador justificó la ocurrencia. La gestión sale de las pestañas Pendientes y Aplicadas y pasa a Gestiones desconsideradas, y las ocurrencias siguen tratadas en el Informe de ocurrencias.',
    'gestoes.desconsideracao.erro': 'Informe la justificación y quién pidió desconsiderar.',
    'gestoes.acao.desconsiderar': 'Gestión desconsiderada',
    'gestoes.vazio.desconsiderada': 'Ninguna gestión desconsiderada con los filtros actuales.',
    'gestoes.hint.desconsiderada': 'Gestiones desconsideradas porque el colaborador las justificó. El período y las fechas filtran por la fecha de la ocurrencia, en la nómina del día 16 al día 15; sin fecha, aparecen todas.',
  },
}
